import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  // Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { CandidateSubmissionType } from 'components/JobQueue/utils';
import { Loader } from 'components/loader';
import { SalesRoute } from 'config';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface JobQueueTableProps {
  selectedRows: string[];
  onRowSelect: (id: string) => void;
  onSelectAll: (selected: boolean) => void;
  loading?: boolean;
  users: CandidateSubmissionType[];
}

const CandidateTable: React.FC<JobQueueTableProps> = ({
  selectedRows,
  onRowSelect,
  onSelectAll,
  loading = false,
  users,
}) => {
  const { VIEWipriseJOB } = SalesRoute;
  const navigate = useNavigate();
  // const isAllSelected = data.length > 0 && selectedRows.length === data.length;
  // const isIndeterminate =
  //   selectedRows.length > 0 && selectedRows.length < data.length;

  const navigateTo = (jobId: string) => {
    navigate(`${VIEWipriseJOB}/${jobId ?? '1'}`);
  };
  // const getStatusBadgeColor = (color: string) => {
  //   switch (color) {
  //     case 'green':
  //       return '#10b981';
  //     case 'orange':
  //       return '#f59e0b';
  //     case 'red':
  //       return '#ef4444';
  //     default:
  //       return '#6b7280';
  //   }
  // };

  const displayData = users.length > 0 ? users : [];

  return (
    <div className={'more-candidate-table job-queue-table'}>
      <Table sx={{ minWidth: 650 }} aria-label="job queue table">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <div style={{ alignItems: 'center', display: 'flex' }}>
                {/* <Checkbox
                  checked={isAllSelected}
                  indeterminate={isIndeterminate}
                  onChange={(e) => onSelectAll(e.target.checked)}
                  sx={{
                    marginRight: '8px',
                    padding: '4px',
                  }}
                /> */}
                <Typography
                  sx={{
                    color: '#000000 !important',
                    fontFamily: 'Red Hat Display semibold !important',
                    fontSize: '13px',
                    fontWeight: 500,
                  }}>
                  Name
                </Typography>
              </div>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Email
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Phone
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Loaction
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Visa Status
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Relocation Status
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Pay
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  // color: '181D1F',
                  // fontFamily: 'Red Hat Display Medium',
                  // fontSize: '14px',
                  // fontWeight: 500,
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Match%
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                '&::after': {
                  backgroundColor: '#e5e7eb',
                  content: '""',
                  height: '24px',
                  position: 'absolute',
                  right: 0,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  width: '2px',
                },
                padding: '12px 16px',
                position: 'relative',
              }}>
              <Typography
                sx={{
                  color: '#000000 !important',
                  fontFamily: 'Red Hat Display semibold !important',
                  fontSize: '13px',
                  fontWeight: 500,
                }}>
                Status
              </Typography>
            </TableCell>
            <TableCell sx={{ padding: '12px 16px' }} />
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell
                colSpan={10}
                align="center"
                sx={{
                  color: '#241a2e',
                  fontFamily: 'Red Hat Display Bold',
                  fontSize: '14px',
                  padding: '20px',
                  textAlign: 'center',
                }}>
                <Loader newLoader />
              </TableCell>
            </TableRow>
          ) : displayData.length > 0 ? (
            displayData.map((row) => (
              <TableRow
                key={row.id}
                hover
                sx={{
                  '&:hover': {
                    backgroundColor: '#f9fafb',
                  },
                  cursor: 'pointer',
                }}
                onClick={() => navigateTo(row.id)}>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <div style={{ alignItems: 'center', display: 'flex' }}>
                    {/* <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() => onRowSelect(row.id)}
                      sx={{
                        marginRight: '8px',
                        padding: '4px',
                      }}
                    /> */}
                    <Typography
                      sx={{
                        color: '#000000',
                        fontFamily: 'Red Hat Display Regular',
                        fontSize: '12px',
                        fontWeight: 400,
                      }}>
                      {(() => {
                        const first = row?.candidate?.firstName?.trim();
                        const middle = row?.candidate?.middleName?.trim();
                        const last = row?.candidate?.lastName?.trim();
                        if (first || middle || last) {
                          return [first, middle, last]
                            .filter(Boolean)
                            .join(' ');
                        }
                        return '-';
                      })()}
                    </Typography>
                  </div>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display Regular',
                      fontSize: '12px',
                      fontWeight: 400,
                    }}>
                    {row?.candidate?.email || '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display Regular',
                      fontSize: '12px',
                      fontWeight: 400,
                      marginBottom: '2px',
                      marginRight: '4px',
                      maxWidth: '330px',
                      padding: '2px 6px',
                    }}>
                    {row?.candidate?.phone ||
                      row?.candidate?.mobileNumber ||
                      '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display Regular',
                      fontSize: '12px',
                      fontWeight: 400,
                    }}>
                    {`${
                      row?.candidate?.city?.trim() ? row?.candidate?.city : ''
                    }, ${
                      row?.candidate?.state?.trim() ? row?.candidate?.state : ''
                    }`.trim() || '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display Regular',
                      fontSize: '12px',
                      fontWeight: 400,
                    }}>
                    {row?.candidate?.workStatus?.name || '-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display Regular',
                      fontSize: '12px',
                      fontWeight: 400,
                    }}>
                    {'-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display Regular',
                      fontSize: '12px',
                      fontWeight: 400,
                    }}>
                    {'-'}
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <Typography
                    sx={{
                      color: '#000000',
                      fontFamily: 'Red Hat Display Regular',
                      fontSize: '12px',
                      fontWeight: 400,
                    }}>
                    {row?.matchPercentage || '-'}%
                  </Typography>
                </TableCell>
                <TableCell sx={{ padding: '12px 16px' }}>
                  <CheckCircleIcon
                    sx={{
                      color: '#0E700E',
                      fontFamily: 'Red Hat Display semibold',
                      fontSize: '12px',
                      fontWeight: '600',
                      marginRight: '6px',
                    }}
                  />
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={10} align="center" sx={{ padding: '20px' }}>
                <Typography
                  sx={{
                    color: '#6b7280',
                    fontFamily: 'Red Hat Display Regular',
                    fontSize: '14px',
                  }}>
                  No Matches Found.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default CandidateTable;
